import React, { useEffect, useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { deleteSpacer } from "Stores/actions";
import { SAVE_ALL_SPACER } from "Stores/actionTypes";
import * as Icons from 'react-bootstrap-icons';

function DeleteSpacer({ row }) {
  const { dataRelationSpacer, spacersPagination, spacers } = useSelector(
    (state) => ({
      dataRelationSpacer: state.shishe.dataRelationSpacer,
      spacersPagination: state.shishe.spacersPagination,
      spacers: state.shishe.spacers,
    })
  );
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteSpacer(data));
      if (res) {
        onShowAlert();
        dispatch({
          type: SAVE_ALL_SPACER,
          spacers: spacers.filter((item) => item.Id !== row.Id),
          spacersPagination: spacersPagination,
        });
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationSpacer);
  }, [dataRelationSpacer]);

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={
          (row.IsG && read("StypeU") !== "1") ||
          row.Disable ||
          read("SpacerRules").accessDelete === false
        }
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteSpacer;
